import { Component, input, OnInit } from '@angular/core';

import { IntakeOutputAssessment } from 'src/app/calvin-emr-shared/models/assessments/intake-output.model';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';

@Component({
  selector: 'app-intake-output-info',
  templateUrl: './intake-output-info.component.html',
  styleUrls: ['./intake-output-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent],
})
export class IntakeOutputInfoComponent
  extends AssessmentInfoComponent<IntakeOutputAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  ngOnInit(): void { }
}
